<template>
  <div>
    <vx-card class="mb-4">
      <FormDetailInclude :id="id" ></FormDetailInclude>
      <div class="w-full flex gap-2 justify-end pt-4">
        <b-button
          v-permission="'newsletters_moderator.handling'"
          variant="primary"
          class="float-right"
          @click="moderate">
          <feather-icon
            icon="CheckIcon"
            class="mr-50"/>
          <span class="align-middle">{{$t('newsletter.comment_moderate')}}</span>
        </b-button>
        <b-button
          variant="outline-secondary"
          class="float-right"
          @click="goBack">
          <feather-icon
            icon="CornerUpLeftIcon"
            class="mr-50"/>
          <span class="align-middle">{{$t('back')}}</span>
        </b-button>
      </div>
    </vx-card>
  </div>
</template>

<script>

import { isAdmin } from '@/util/Util'
import {
  BRow,
  BCol,
  BCardText,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BIconClipboard,
  VBTooltip,
} from 'bootstrap-vue'


import FormDetailInclude from './FormDetailInclude'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BCardText,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BIconClipboard,
    FormDetailInclude
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,

  }),
  computed: {

  },
  beforeMount() {

  },
  mounted() {
    if (this.id) {

    }
  },
  beforeDestroy() {
    this.destroyChilds(this)
  },
  methods: {
    goBack() {
      this.$router.push('/newsletters')
    },
    moderate() {
      this.$router.push({
        name: 'newsletter-moderator-comments',
        params: {
          id: this.id
        }
      })
    },
    isAdmin() {
      return isAdmin()
    },
  }
}
</script>

<style>

</style>
